import { render, staticRenderFns } from "./ProjectFonts.vue?vue&type=template&id=39ade0d2"
import script from "./ProjectFonts.vue?vue&type=script&lang=js"
export * from "./ProjectFonts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports